module.exports = __webpack_public_path__ + "media/images/doctor_profiles/modal/sp/search_result_page/prefecture-a2cc16a1937de666857d91a3b69f3f92.png";